import { defineStore } from 'pinia';

export const useContentStore = defineStore({
    id: 'content',
    state: () => ({
        areaId: document.documentElement.getAttribute('data-area-id'),
        baseFetchUrl: '/dwapi/content',
        pages: [],
        paragraphs: [],
        isLoading: false
    }),
    getters: {
        getPage: state => pageId => state.pages.find(x => x.ID == pageId),
        getPagesByAreaId: state => areaId => state.pages.filter(x => x.Path.find(x => x.AreaID == areaId)),
        getPagesByParentId: state => pageId => state.pages.filter(x => x.Path.find(x => x.ID == pageId)),
        getParagraphs: state => pageId => (state.paragraphs || []).filter(x => x.PageID == pageId),
        getParagraph: state => paragraphId => (state.paragraphs.filter(x => x.ID == paragraphId) || [])[0]
    },
    actions: {
        async fetchParagraphs(pageId) {
            if (this.paragraphs.filter(x => x.PageID == pageId).length == 0) {
                await fetch(`${this.baseFetchUrl}/paragraphs?pageid=${pageId}`, {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        this.paragraphs = this.paragraphs.concat(data);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        async fetchParagraph(paragraphId) {
            if (this.paragraphs.filter(x => x.ID == paragraphId).length == 0) {
                await fetch(`${this.baseFetchUrl}/paragraphs/${paragraphId}`, {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        this.paragraphs = this.paragraphs.concat(data);
                    })
            }
        },
        async fetchPages(parentPageId) {
            if (this.pages.filter(x => x.Path.find(x => x.ID == parentPageId)).length == 0) {
                await fetch(`${this.baseFetchUrl}/pages?pageid=${parentPageId}`, {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        this.pages = this.pages.concat(data);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        async fetchPagesByArea(areaId) {
            if (this.pages.filter(x => x.AreaID == areaId).length == 0) {
                await fetch(`${this.baseFetchUrl}/pages?areaid=${areaId}`, {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        this.pages = this.pages.concat(data);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        async fetchPage(pageId) {
            if (this.pages.find(x => x.ID == pageId) == undefined) {
                await fetch(`${this.baseFetchUrl}/pages/${pageId}`, {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                })
                    .then(response => response.json())
                    .then(data => {
                        this.pages = this.pages.concat(data);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
});
